import { types } from 'mobx-state-tree'

export const MeasurementUnitModel = types.model('MeasurementUnitModel', {
  id: types.number,
  name: types.string,
  isDeletable: types.boolean,
})
